import * as v from 'valibot'

export const SearchAutocompleteSchema = v.array(v.string())
